import {Rule} from 'antd/lib/form';

export const nameValidate: Rule[] = [
    {required: true, message: ''},
    {pattern: /^[a-zA-Z-_\u4e00-\u9fa5]{0,60}$/, message: ''},
];

export const cpromInstanceValidate: Rule[] = [
    {required: true, message: '请选择监控实例'},
];

export const cpromTokenValidate: Rule[] = [
    {required: true, message: ''},
];
